const languageNames = new Intl.DisplayNames(['en'], { type: 'language' })
const regionNames = new Intl.DisplayNames(['en'], { type: 'region' })

export function formatLocaleLabel(locale: string): string {
  // Locale data is regenerated each build, so tolerate language-only or
  // otherwise unexpected tags instead of throwing at render time
  try {
    const { language, region } = new Intl.Locale(locale)
    const languageName = languageNames.of(language) ?? locale
    return region ? `${languageName} (${regionNames.of(region)})` : languageName
  } catch {
    return locale
  }
}
